"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITELIST = exports.PAGE_ID = exports.INCLUSION_STATE = exports.ID = exports.DOI_PAGES = exports.BLACKLIST = exports.ACTIVE = void 0;
var ACTIVE = 'active';
exports.ACTIVE = ACTIVE;
var BLACKLIST = 'BLACKLIST';
exports.BLACKLIST = BLACKLIST;
var DOI_PAGES = 'DoiPages';
exports.DOI_PAGES = DOI_PAGES;
var ID = 'id';
exports.ID = ID;
var INCLUSION_STATE = 'inclusionState';
exports.INCLUSION_STATE = INCLUSION_STATE;
var PAGE_ID = 'pageId';
exports.PAGE_ID = PAGE_ID;
var WHITELIST = 'WHITELIST';
exports.WHITELIST = WHITELIST;